import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ErrorPage from '../app/pages/error'
import { EventNotFound } from '../app/pages/EventNotFound'
import { Splash } from '../app/components/Splash'
import { LiveEvent } from '../app/pages/LiveEvent'
import { ScheduledEvent } from '../app/pages/ScheduledEvent'
import LinxRedirector from '../app/pages/LinxRedirector'
import { DefaultError } from '../app/pages/DefaultError'
import { FinishedEventSurvey } from '../app/pages/FinishedEventSurvey'
import { DeepLink } from '../app/pages/deepLink'
import { useDocumentTitle } from '../app/hooks/useDocumentTitle'
import { PostHogTracker } from './postHogTracker'
import { FinishedEvent } from '../app/pages/FinishedEvent'
import { StorePages } from '../app/pages/store-pages'

export const AppRouter = () => {
  useDocumentTitle()

  return (
    <Router>
      <PostHogTracker />
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/store/:storeId" element={<StorePages />} />
        <Route path="/store/:storeId/event/:eventId/scheduled" element={<ScheduledEvent />} />
        <Route path="/store/:storeId/event/:eventId/live" element={<LiveEvent />} />
        <Route path="/store/:storeId/event/:eventId/finished" element={<FinishedEvent />} />
        <Route
          path="/store/:storeId/event/:eventId/finished/survey"
          element={<FinishedEventSurvey />}
        />
        <Route path="/store/:storeId/event/not-found" element={<EventNotFound />} />
        <Route path="error" element={<ErrorPage />} />
        <Route path="/store/error" element={<DefaultError />} />
        <Route path="/linx/redirect" element={<LinxRedirector />} />
        <Route path="/deeplink.*" element={<DeepLink />} />
      </Routes>
    </Router>
  )
}
